var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4633 4.93232C15.9749 3.33018 13.5902 3.33018 12.1018 4.93232L12.0737 4.96255C11.3879 5.70083 10.2193 5.70083 9.53343 4.96255L9.50534 4.93232C8.017 3.33018 5.63224 3.33018 4.1439 4.93232C2.62163 6.57097 2.62163 9.25236 4.1439 10.891L10.8036 18.0599L17.4633 10.891C18.9855 9.25236 18.9855 6.57097 17.4633 4.93232ZM10.8317 3.75238C13.0058 1.41197 16.5592 1.41197 18.7334 3.75238C20.8737 6.05628 20.8737 9.76705 18.7334 12.0709L12.0737 19.2398C11.3879 19.9781 10.2193 19.9781 9.53343 19.2398L2.87375 12.0709C0.73349 9.76705 0.73349 6.05628 2.87375 3.75238C5.04793 1.41197 8.60131 1.41197 10.7755 3.75238L10.8036 3.78262L10.8317 3.75238Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLike);
export default __webpack_public_path__ + "static/media/instagramLike.00b2b117.svg";
export { ForwardRef as ReactComponent };